import { render, staticRenderFns } from "./ProductCardList.vue?vue&type=template&id=613f9e1e&scoped=true"
import script from "./ProductCardList.vue?vue&type=script&lang=js"
export * from "./ProductCardList.vue?vue&type=script&lang=js"
import style0 from "./ProductCardList.vue?vue&type=style&index=0&id=613f9e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f9e1e",
  null
  
)

export default component.exports